import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Constants } from 'src/shared/utilities/constants.util';
import { EntityAdminConfig } from 'src/shared/Baseclasses/entity-admin.component';
import { JobTitle } from 'src/shared/models/job-title.model';
import { JobTitleService } from 'src/shared/services/job-title.service';
import { PageLayoutService } from 'src/shared/services/page-layout.service';
import { RemoveMasterListFailure } from 'src/shared/enum/remove-master-list-failure.enum';

@Component({
  selector: 'smt-job-title',
  templateUrl: './job-title.component.html',
  styleUrls: ['./job-title.component.scss']
})
export class JobTitleComponent extends EntityAdminConfig implements OnDestroy, OnInit {
    @ViewChild('jobTitleEditForm') public jobTitleEditForm: NgForm;
  
  jobTitles: JobTitle[];
  mostRecent: boolean;
  selectedAbbreviation: string;
  selectedPosition: string;
  showCostCenterWarning:boolean=false;
  costCenterNames: string[];
  costCenterListModalActive: boolean = false;
  jobTitleName:string;

  constructor(private _jobTitleService: JobTitleService, private _pageLayout: PageLayoutService) { 
    super(_pageLayout); 
  }

  ngOnDestroy() {
		super.cleanUp();
	}

  ngOnInit() {
    super.initialize(
        Constants.JobTitles,
        [ "Position", "Abbreviation", "Last Modified" ],
        async() => this.setSelectedJobTitleValues(), 
        async(mostRecent: boolean) => this.refreshJobTitleList(mostRecent), 
        async() => this.appendJobTitleList(),
        async() => this.saveJobTitle(),
        () => this.setCurrentSelectionLabel(),
        () => { return "Remove"; });
  }    
  
  async appendJobTitleList(): Promise<void> {
		let result = await this._jobTitleService.getJobTitlesInfiniteScroll(
                                              false,
                                              this.offset, 
                                              this.itemsPerPage, 
                                              this.searchText, 
                                              this.selectedFilter, 
                                              this.getSortOrderString());

		this.jobTitles = this.jobTitles.concat(result);		
  }
  
  onAddJobTitleClick() {    
		this.selection = { 
			id: 0,
			abbreviation: '',
			position: '',
			modifiedByUserName: '',
            modifiedDate: null
		};

    this.showAdminActionWindow = true;
    super.limitAdminActionLabel();
        this.setSelectedJobTitleValues();
        this.showCostCenterWarning=false;
  }

  onCancel() {
		super.onCancel();
		this.setSelectedJobTitleValues();
		this.resetForm();
  }

  onSelection(jobTitle: JobTitle) {
      this.resetForm();
      super.onSelection(jobTitle);
  }

    async onRemoveJobTitleClick() {
        if (!this.selection) {
            return;
        }

        let result = await this._jobTitleService.removeJobTitle(this.selection.id);
        if(result==RemoveMasterListFailure.CostCenterAssociation)
        this.showCostCenterWarning=true;
        this.confirmModalActive =false;
        if (result==RemoveMasterListFailure.None) {
            super.refreshAdminList(false, false);
        }
        else {
            super.setErrorMessage("Job title delete failed.");
        }
    }
    async getCostCentersByJobTitleId(openModal:boolean) {
        if (!this.selection) {
          return;
        }
      this.jobTitleName=this.selection.position;
      this.costCenterNames = await this._jobTitleService.getCostCentersByJobTitleId(this.selection.id);
      this.costCenterListModalActive = openModal;
      }

  async refreshJobTitleList(mostRecent: boolean): Promise<JobTitle[]> {    
    let result = await this._jobTitleService.getJobTitlesInfiniteScroll(
                                                mostRecent,
                                                this.offset, 
                                                this.itemsPerPage, 
                                                this.searchText, 
                                                this.selectedFilter, 
                                                this.getSortOrderString());

    this.jobTitles = result;

    this.setSelectedJobTitleValues();
    this.resetForm();

    return result;
  }

  resetForm() {
		if (!this.jobTitleEditForm) {
			return;
		}

		Object.keys(this.jobTitleEditForm.controls).forEach(control => {
			this.jobTitleEditForm.controls[control].markAsPristine();
		});
	}

    async saveJobTitle() {
        if (!this.selection) { 
                return; 
        }

        let mostRecent = this.selection.id == 0;

        let selectedJobTitle = new JobTitle;

        selectedJobTitle.id = this.selection.id;
        selectedJobTitle.abbreviation = this.selectedAbbreviation;
        selectedJobTitle.position = this.selectedPosition;

        //When creating a new item check if there is a duplicate
        let result = await this._jobTitleService.setJobTitle(selectedJobTitle);
        if (result.errorMessage) {
        super.setErrorMessage(result.errorMessage);
        }
        else if(result.id>0) {      
            this.selection.id = result.id; 
            this.selection.abbreviation = result.abbreviation;
            this.selection.position = result.position; 

            await super.refreshAdminList(mostRecent, true);
        
            this.resetForm();
            }
            else {
                super.setErrorMessage("Job title failed to save.");
            }
        }
    

    setCurrentSelectionLabel(): string {
        if (!this.selection) {
            return "";
        }

        if (this.selection.id == 0) {
            return "New Abbreviation";
        }

        return this.selection.abbreviation;
    }

    setSelectedJobTitleValues() {
        super.setErrorMessage("");

        if (this.selection) {
            this.selectedAbbreviation = this.selection.abbreviation;
            this.selectedPosition = this.selection.position;
        }
        else {
            this.selectedAbbreviation = "";
            this.selectedPosition = "";
        }
        this.showCostCenterWarning=false;
    }
}
